import { View } from 'backbone.marionette';
import { LeagueFilterModel } from '../../../models';
import Radio from 'backbone.radio';

const joinChannel = Radio.channel( 'join' );

/**
 * @desc Table Core Join Filter Class
 */
export default class CoreJoinFilterView extends View {

	get template() {
		throw new Error("Need set template for child CoreJoinFilterView class");
	}

	/**
	 * Set all UI for this view
	 * @returns object
	 */
	ui() {
		return {
			sort_by_team: '.js-sort-by-team',
			type_filter:  '.js-filter-by',
		};
	}

	/**
	 * Create events for this UI
	 * @returns object
	 */
	events() {
		return {
			'click @ui.sort_by_team': 'sortByTeam',
			'change @ui.type_filter': 'searchLeagueBy',
		};
	}

	initialize() {
		this.model = new LeagueFilterModel;
	}

	sortByTeam() {
		joinChannel.trigger( 'join:order:by' );
	}

	searchLeagueBy( element ) {
		let data     = {},
			$element = $( element.currentTarget );

		data.val = $element.val();
		data.key = $element.find( 'option:selected' ).parent().data( 'type' );

		joinChannel.trigger( 'join:filter:by', data );
	}

}